"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Button = require("@ccw-pwa-ui/Button");
var _Modal = require("@ccw-pwa-ui/Modal");
var _images = _interopRequireWildcard(require("../../common_features/assets/images"));
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
var _strings = require("../../common_features/utility/strings");
var _helper = require("../../common_features/utility/helper");
require("../../styles/ServiceLogsComponent.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ServiceLogOperations = _ref => {
  var _Object$keys, _successModaldata$Sys2, _successModaldata$Sys3, _Object$values, _Object$keys3, _image$slice2;
  let {
    navHeading,
    handleBack,
    editImage,
    onEditClick,
    leftArrowImage,
    headerText,
    systemNameKey,
    systemNameValue,
    installDateKey,
    installDateValue,
    lastServiceLogDateKey,
    lastServiceLogDateValue,
    updatedByKey,
    updatedByValue,
    serviceProvNameKey,
    serviceProvNameValue,
    systemDetail,
    systemDetailClick,
    arrowIcon,
    waterInfoRightIcon,
    successModaldata,
    isAccessoryPresent,
    isOpenSysDetail,
    waterInfo,
    isOpenWaterInfo,
    waterInfoClick,
    notes,
    notesText,
    notesNotVisible,
    image,
    photo,
    isLoading,
    viewImage,
    viewImageClick,
    crossIconAction,
    handleImageClick,
    selectedImage,
    caption,
    zoomCarousel,
    readings,
    readingsKey,
    isWaterInfoVisible,
    isImageVisible,
    timelineData,
    imageListStyle,
    onCancleBtnClick,
    onChangeNotes,
    editClicked,
    saveContinueBtnClick,
    systemDetailVisible,
    timelineNotVisible,
    logHeader,
    imageModalStyle,
    wrapperStyle,
    captionContainer,
    selectedImageStyle,
    scrollableItem,
    unselectedImage,
    imageVariant,
    EditText,
    dispatcher,
    accessoryAdded,
    systemData,
    logVisible,
    systemModelValue,
    maxLengthText,
    noPhoto,
    historyVisible,
    openIndex,
    listData
  } = _ref;
  return isLoading ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "main-div"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeading,
    handleBack: handleBack,
    leftArrowImage: leftArrowImage,
    headerText: headerText
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "container-style"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: 20
    },
    "data-testid": "title-text"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "middle-text-service-log"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 15,
      color: "#333333",
      fontWeight: 400,
      marginRight: 4
    },
    variant: "header-text",
    headerText: systemNameKey
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "part-number"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 14,
      color: "#333333",
      fontWeight: 600,
      textAlign: "right"
    },
    variant: "header-text",
    headerText: systemNameValue
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "model-name"
  }, systemModelValue))), /*#__PURE__*/_react.default.createElement("div", {
    className: "middle-text-service-log"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 15,
      color: "#333333",
      fontWeight: 400,
      marginRight: 4
    },
    variant: "header-text",
    headerText: installDateKey
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 14,
      color: "#333333",
      fontWeight: 600
    },
    variant: "header-text",
    headerText: installDateValue
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "middle-text-service-log"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 15,
      color: "#333333",
      fontWeight: 400,
      marginRight: 4,
      marginTop: 5
    },
    variant: "header-text",
    headerText: lastServiceLogDateKey
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 14,
      color: "#333333",
      fontWeight: 600,
      marginTop: 10,
      textAlign: "right"
    },
    variant: "header-text",
    headerText: lastServiceLogDateValue
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "middle-text-service-log"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 15,
      color: "#333333",
      fontWeight: 400,
      marginRight: 4
    },
    variant: "header-text",
    headerText: serviceProvNameKey
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 14,
      color: "#333333",
      fontWeight: 600,
      textAlign: "right"
    },
    variant: "header-text",
    headerText: serviceProvNameValue
  }))), systemDetailVisible && /*#__PURE__*/_react.default.createElement("div", {
    className: "updated_by"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontFamily: "Poppins",
      fontSize: "11px",
      fontStyle: "italic",
      fontWeight: 400,
      textAlign: "left",
      color: "#9A9A9A"
    },
    variant: "header-text",
    headerText: updatedByKey
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "updated_by_val"
  }, updatedByValue)), timelineNotVisible ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: "log-container"
  }, (timelineData === null || timelineData === void 0 ? void 0 : timelineData.length) > 0 && systemData && ((_Object$keys = Object.keys(listData)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map((log, index) => {
    var _successModaldata$Sys, _listData$log$, _listData$log$$system;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "dropdown-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "dropdown-text"
    }, /*#__PURE__*/_react.default.createElement("div", null, !accessoryAdded && (successModaldata === null || successModaldata === void 0 ? void 0 : (_successModaldata$Sys = successModaldata.SystemReferenceMappings) === null || _successModaldata$Sys === void 0 ? void 0 : _successModaldata$Sys.map(refType => {
      var _listData$log$0$Syste;
      return (refType === null || refType === void 0 ? void 0 : refType.refAppId) === ((_listData$log$0$Syste = listData[log][0].SystemReferenceMapping) === null || _listData$log$0$Syste === void 0 ? void 0 : _listData$log$0$Syste.refAppId) ? /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
        headerStyle: {
          fontFamily: "Poppins",
          fontSize: 16,
          fontWeight: 600,
          letterSpacing: 0,
          textAlign: "left",
          marginLeft: 25,
          color: "#333333",
          marginBottom: 5
        },
        variant: "header-text",
        headerText: refType.refAppType === 'Replacement Part' ? refType.refAppName + " { " + "".concat(refType.refAppModelNumber) + " }" : refType === null || refType === void 0 ? void 0 : refType.refAppModelNumber
      }) : null;
    })), accessoryAdded && /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
      headerStyle: {
        fontFamily: "Poppins",
        fontSize: 16,
        fontWeight: 600,
        letterSpacing: 0,
        textAlign: "left",
        marginLeft: 25,
        color: "#333333",
        marginBottom: 5
      },
      variant: "header-text",
      headerText: "".concat(((_listData$log$ = listData[log][0]) === null || _listData$log$ === void 0 ? void 0 : (_listData$log$$system = _listData$log$.systemGeneratedLogs) === null || _listData$log$$system === void 0 ? void 0 : _listData$log$$system.accessoryCount) + " Accessories added")
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "dropdown-arrow",
      onClick: () => systemDetailClick(index),
      "data-testid": "system-detail-arrow"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: openIndex !== null && openIndex !== void 0 && openIndex.includes(index) ? _images.default.arrowUp.default : _images.default.arrowDown.default,
      alt: "arrow-icon",
      key: index
    }))), (openIndex === null || openIndex === void 0 ? void 0 : openIndex.includes(index)) && Object.keys((0, _helper.groupLogs)(listData[log])).map(details => {
      var _image$slice, _groupLogs$details$0$, _groupLogs$details$0$2, _groupLogs$details$0$3;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "timeline-container"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "updated_by"
      }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
        headerStyle: {
          fontFamily: "Poppins",
          fontSize: "11px",
          fontStyle: "italic",
          fontWeight: 400,
          textAlign: "left",
          color: "#9A9A9A"
        },
        variant: "header-text",
        headerText: updatedByKey
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "updated_by_val"
      }, updatedByValue)), (0, _helper.groupLogs)(listData[log])[details].map(timeLineText => {
        var _Object$keys2;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "timeline"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "timeline_dot"
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "dots-container"
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "timeline-date"
        }, (0, _helper.formatTimeDateString)(timeLineText === null || timeLineText === void 0 ? void 0 : timeLineText.updatedAt)), (_Object$keys2 = Object.keys(timeLineText === null || timeLineText === void 0 ? void 0 : timeLineText.systemGeneratedLogs)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.map(logText => /*#__PURE__*/_react.default.createElement("p", {
          className: "timeline-text",
          dangerouslySetInnerHTML: {
            __html: logText !== "accessoryCount" ? timeLineText === null || timeLineText === void 0 ? void 0 : timeLineText.systemGeneratedLogs[logText] : null
          }
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "timeline-border"
        }));
      }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          marginTop: "25px",
          paddingBottom: "7px"
        }
      }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
        headerStyle: {
          fontFamily: "Poppins",
          fontSize: 16,
          fontWeight: 600,
          margin: 25,
          color: "#333333"
        },
        variant: "header-text",
        headerText: "".concat(photo, " (").concat(image === null || image === void 0 ? void 0 : image.length, ")")
      }), (!zoomCarousel || (image === null || image === void 0 ? void 0 : image.length) === 0) && /*#__PURE__*/_react.default.createElement("div", {
        className: "img_not_added"
      }, "Not added"), isImageVisible && (image === null || image === void 0 ? void 0 : image.length) !== 0 && /*#__PURE__*/_react.default.createElement("div", {
        className: "image-container",
        onClick: viewImageClick
      }, image === null || image === void 0 ? void 0 : (_image$slice = image.slice(0, 3)) === null || _image$slice === void 0 ? void 0 : _image$slice.map(item => /*#__PURE__*/_react.default.createElement("img", {
        src: item,
        alt: "",
        className: "image-area"
      })), (image === null || image === void 0 ? void 0 : image.length) > 3 && /*#__PURE__*/_react.default.createElement("div", {
        className: "more-images"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "image-count",
        "data-testid": "image-count"
      }, "+ ".concat((image === null || image === void 0 ? void 0 : image.length) - 3))))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          paddingBottom: "20px"
        }
      }, notesNotVisible ? null : editClicked ? /*#__PURE__*/_react.default.createElement("div", {
        className: "notes-input"
      }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
        headerStyle: {
          fontFamily: "Poppins",
          fontSize: 16,
          fontWeight: 600,
          margin: 0,
          color: "#333333"
        },
        variant: "header-text",
        headerText: notes
      }), /*#__PURE__*/_react.default.createElement("textarea", {
        "data-testid": "text-area",
        maxLength: 250,
        onChange: onChangeNotes,
        style: {
          borderRadius: "10px",
          borderColor: "#EBEBEB",
          padding: "10px",
          height: "Hug (121px)",
          width: "100%",
          outline: "none",
          border: "1px solid #006E96",
          marginTop: "10px"
        }
      }, (_groupLogs$details$0$ = (0, _helper.groupLogs)(listData[log])[details][0].ServiceLogNotes[0]) === null || _groupLogs$details$0$ === void 0 ? void 0 : _groupLogs$details$0$.note), /*#__PURE__*/_react.default.createElement("div", {
        className: "sub-notes",
        "data-testid": "sub-notes"
      }, maxLengthText), /*#__PURE__*/_react.default.createElement(_Button.Button, {
        variant: "primary-long",
        title: "Save",
        buttonStyle: {
          width: "65px",
          height: "40px",
          marginLeft: "203.5px",
          padding: "10px, 16px, 10px, 16px",
          borderRadius: "5px",
          gap: "10px"
        },
        onClick: () => saveContinueBtnClick(index)
      }), /*#__PURE__*/_react.default.createElement(_Button.Button, {
        variant: "nav-link-button",
        title: "Cancel",
        buttonStyle: {
          width: "65px",
          height: "40px",
          marginTop: "-40px",
          marginLeft: "270px",
          padding: "10px, 16px, 10px, 16px",
          borderRadius: "5px",
          gap: "10px"
        },
        onClick: onCancleBtnClick
      })) : /*#__PURE__*/_react.default.createElement("div", {
        className: "notes-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "auto"
        }
      }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
        headerStyle: {
          fontFamily: "Poppins",
          fontSize: 16,
          fontWeight: 600,
          letterSpacing: 0,
          textAlign: "left",
          margin: 10,
          color: "#333333",
          marginBottom: 5
        },
        variant: "header-text",
        headerText: notes
      }), dispatcher && /*#__PURE__*/_react.default.createElement("div", {
        onClick: onEditClick,
        "data-testid": "edit_pencil"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: editImage,
        alt: "",
        className: "edit_pencil"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "edit_text"
      }, EditText))), (_groupLogs$details$0$2 = (0, _helper.groupLogs)(listData[log])[details][0].ServiceLogNotes[0]) !== null && _groupLogs$details$0$2 !== void 0 && _groupLogs$details$0$2.note ? /*#__PURE__*/_react.default.createElement("div", {
        className: "notes-text"
      }, (_groupLogs$details$0$3 = (0, _helper.groupLogs)(listData[log])[details][0].ServiceLogNotes[0]) === null || _groupLogs$details$0$3 === void 0 ? void 0 : _groupLogs$details$0$3.note) : /*#__PURE__*/_react.default.createElement("div", {
        className: "notes_not_added"
      }, "Not added"))))));
    }));
  }))), systemDetailVisible && /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-text"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontFamily: "Poppins",
      fontSize: 16,
      fontWeight: 600,
      letterSpacing: 0,
      textAlign: "left",
      marginLeft: 25,
      color: "#333333",
      marginBottom: 5
    },
    variant: "header-text",
    headerText: systemDetail
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-arrow",
    onClick: systemDetailClick,
    "data-testid": "system-detail-arrow"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: arrowIcon,
    alt: "arrow-icon"
  }))), isOpenSysDetail && /*#__PURE__*/_react.default.createElement("div", {
    className: "description-text"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "system-detail-value"
  }, "The below components have been added:"), /*#__PURE__*/_react.default.createElement("div", {
    className: "system-detail"
  }, "System:"), /*#__PURE__*/_react.default.createElement("div", {
    className: "system-detail-value"
  }, successModaldata === null || successModaldata === void 0 ? void 0 : successModaldata.systemModelNumber), /*#__PURE__*/_react.default.createElement("div", {
    className: "system-detail"
  }, "Filters:"), successModaldata === null || successModaldata === void 0 ? void 0 : (_successModaldata$Sys2 = successModaldata.SystemReferenceMappings) === null || _successModaldata$Sys2 === void 0 ? void 0 : _successModaldata$Sys2.map(item => {
    if (item.refAppType === "Replacement Part") {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "system-detail-value",
        key: item.refAppModelNumber
      }, item.refAppModelNumber);
    }
  }), isAccessoryPresent ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "system-detail"
  }, "Accessories:"), successModaldata === null || successModaldata === void 0 ? void 0 : (_successModaldata$Sys3 = successModaldata.SystemReferenceMappings) === null || _successModaldata$Sys3 === void 0 ? void 0 : _successModaldata$Sys3.map(item => {
    if (item.refAppType === "Accessory") {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "system-detail-value"
      }, /*#__PURE__*/_react.default.createElement("div", {
        key: item.refAppModelNumber
      }, item.refAppModelNumber));
    }
  })) : null)), isWaterInfoVisible && /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-text"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontFamily: "Poppins",
      fontSize: 16,
      fontWeight: 600,
      letterSpacing: 0,
      textAlign: "left",
      marginLeft: 25,
      color: "#333333",
      marginBottom: 5
    },
    variant: "header-text",
    headerText: waterInfo
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-arrow",
    onClick: waterInfoClick,
    "data-testid": "waterInfo-arrow"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: waterInfoRightIcon,
    alt: "arrow-icon"
  }))), isOpenWaterInfo && /*#__PURE__*/_react.default.createElement("div", {
    className: "description-text"
  }, readings && (Object === null || Object === void 0 ? void 0 : (_Object$values = Object.values(readingsKey)) === null || _Object$values === void 0 ? void 0 : _Object$values.map(item => readings[item] !== undefined && /*#__PURE__*/_react.default.createElement("div", {
    className: "list-content"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 13,
      color: "#333333",
      fontWeight: 400,
      width: "70%",
      marginRight: 4,
      flex: 7
    },
    variant: "header-text",
    headerText: _strings.waterInfoValue[item]
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "details-div"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: readings && ["--", null, ""].includes(readings[item]) ? "water_details_empty" : "details_present"
  }, ["--", null, ""].includes(readings[item]) ? "--" : "".concat(readings[item])), /*#__PURE__*/_react.default.createElement("div", {
    className: "water_details"
  }, _strings.waterInfoParams[item]))))))), historyVisible && /*#__PURE__*/_react.default.createElement("div", null, logVisible && systemData && (Object === null || Object === void 0 ? void 0 : (_Object$keys3 = Object.keys(systemData)) === null || _Object$keys3 === void 0 ? void 0 : _Object$keys3.map((logItem, index) => {
    var _systemData$logItem$i, _systemData$logItem$i2, _Object$values2;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "log-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "updated_by"
    }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
      headerStyle: {
        fontFamily: "Poppins",
        fontSize: "11px",
        fontStyle: "italic",
        fontWeight: 400,
        textAlign: "left",
        color: "#9A9A9A"
      },
      variant: "header-text",
      headerText: updatedByKey
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "updated_by_val"
    }, "".concat(((_systemData$logItem$i = systemData[logItem][index]) === null || _systemData$logItem$i === void 0 ? void 0 : (_systemData$logItem$i2 = _systemData$logItem$i.createdBy) === null || _systemData$logItem$i2 === void 0 ? void 0 : _systemData$logItem$i2.userType) === "dispatcher" ? " Dispatcher: " : " Technician: ").concat(" " + logItem))), (_Object$values2 = Object.values(systemData[logItem])) === null || _Object$values2 === void 0 ? void 0 : _Object$values2.map(logText => /*#__PURE__*/_react.default.createElement("div", {
      className: "timeline"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "timeline_dot"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "dots-container"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "timeline-date"
    }, (0, _helper.formatTimeDateString)(logText.updatedAt)), Object.keys(logText === null || logText === void 0 ? void 0 : logText.systemGeneratedLogs).map(text => /*#__PURE__*/_react.default.createElement("p", {
      className: "timeline-text",
      dangerouslySetInnerHTML: {
        __html: text !== "accessoryCount" ? logText === null || logText === void 0 ? void 0 : logText.systemGeneratedLogs[text] : null
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "timeline-border"
    }))));
  })), !noPhoto && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: "25px",
      paddingBottom: "7px"
    }
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontFamily: "Poppins",
      fontSize: 16,
      fontWeight: 600,
      margin: 25,
      color: "#333333"
    },
    variant: "header-text",
    headerText: "".concat(photo, " (").concat(zoomCarousel === null || zoomCarousel === void 0 ? void 0 : zoomCarousel.length, ")")
  }), (zoomCarousel === null || zoomCarousel === void 0 ? void 0 : zoomCarousel.length) === 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "img_not_added"
  }, "Not added"), isImageVisible && (image === null || image === void 0 ? void 0 : image.length) !== 0 && image && /*#__PURE__*/_react.default.createElement("div", {
    className: "image-container",
    onClick: viewImageClick
  }, image === null || image === void 0 ? void 0 : (_image$slice2 = image.slice(0, 3)) === null || _image$slice2 === void 0 ? void 0 : _image$slice2.map(item => /*#__PURE__*/_react.default.createElement("img", {
    src: item,
    alt: "",
    className: "image-area"
  })), (image === null || image === void 0 ? void 0 : image.length) > 3 && /*#__PURE__*/_react.default.createElement("div", {
    className: "more-images"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "image-count",
    "data-testid": "image-count"
  }, "+ ".concat((image === null || image === void 0 ? void 0 : image.length) - 3))))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      paddingBottom: "20px"
    }
  }, notesNotVisible ? null : editClicked ? /*#__PURE__*/_react.default.createElement("div", {
    className: "notes-input"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontFamily: "Poppins",
      fontSize: 16,
      fontWeight: 600,
      margin: 0,
      color: "#333333"
    },
    variant: "header-text",
    headerText: notes
  }), /*#__PURE__*/_react.default.createElement("textarea", {
    "data-testid": "text-area",
    maxLength: 250,
    onChange: onChangeNotes,
    style: {
      borderRadius: "10px",
      borderColor: "#EBEBEB",
      padding: "10px",
      height: "Hug (121px)",
      width: "100%",
      outline: "none",
      border: "1px solid #006E96",
      marginTop: "10px"
    }
  }, notesText), /*#__PURE__*/_react.default.createElement("div", {
    className: "sub-notes",
    "data-testid": "sub-notes"
  }, maxLengthText), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: "Save",
    buttonStyle: {
      width: "65px",
      height: "40px",
      marginLeft: "203.5px",
      padding: "10px, 16px, 10px, 16px",
      borderRadius: "5px",
      gap: "10px"
    },
    onClick: () => saveContinueBtnClick(0)
  }), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "nav-link-button",
    title: "Cancel",
    buttonStyle: {
      width: "65px",
      height: "40px",
      marginTop: "-40px",
      marginLeft: "270px",
      padding: "10px, 16px, 10px, 16px",
      borderRadius: "5px",
      gap: "10px"
    },
    onClick: onCancleBtnClick
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: "notes-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      width: "auto"
    }
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontFamily: "Poppins",
      fontSize: 16,
      fontWeight: 600,
      letterSpacing: 0,
      textAlign: "left",
      margin: 10,
      color: "#333333",
      marginBottom: 5
    },
    variant: "header-text",
    headerText: notes
  }), dispatcher && /*#__PURE__*/_react.default.createElement("div", {
    onClick: onEditClick,
    "data-testid": "edit_pencil",
    className: "edit-area"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: editImage,
    alt: "",
    className: "edit_pencil"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "edit_text"
  }, EditText))), notesText ? /*#__PURE__*/_react.default.createElement("div", {
    className: "notes-text"
  }, notesText) : /*#__PURE__*/_react.default.createElement("div", {
    className: "notes_not_added"
  }, "Not added")))), viewImage && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    imgWidth: "857px",
    imgHeight: "533px",
    variant: "carousel",
    altText: "image-scroll-view",
    handleImageClick: handleImageClick,
    imageListStyle: imageListStyle,
    imageVariant: imageVariant,
    zoomCarousel: zoomCarousel,
    selectedImage: selectedImage,
    caption: caption,
    displayModal: viewImage,
    displayCrossIcon: true,
    crossIconAction: crossIconAction,
    imageModalStyle: imageModalStyle,
    captionContainer: captionContainer,
    selectedImageStyle: selectedImageStyle,
    scrollableItem: scrollableItem,
    unselectedImage: unselectedImage,
    wrapperStyle: wrapperStyle,
    leftArrow: _images.leftImgArrow.default,
    rightArrow: _images.rightArrow.default
  }))));
};
var _default = exports.default = ServiceLogOperations;